
import { useState, useEffect, useRef } from 'react'
import {isMobile} from 'react-device-detect'

import PhotoAlbum from "react-photo-album";
import { FloatingWhatsApp } from 'react-floating-whatsapp'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Navbar from 'react-bootstrap/Navbar'
import Button from 'react-bootstrap/Button'
import Nav from 'react-bootstrap/Nav'

import 'bootstrap/dist/css/bootstrap.min.css'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import './App.css'

import logo from './img/logo.png'
import logoWithe from './img/logo_white.png'
import iconLogo from './img/icon-logo.jpg'
import icons from './img/icons.png'
import chemical01 from './img/chemical01.png'
import chemical02 from './img/chemical02.png'
import chemical03 from './img/chemical03.png'

import location from './img/location_c.png'
import phone from './img/phone_c.png'
import mail from './img/mail_c.png'
import whats from './img/whats.png'

import quimica from './img/quimica.jpg'
import cosmetica from './img/cosmetica.jpg'
import alimentos from './img/alimentos.jpg'
import tinta from './img/tinta.jpg'
import { Facebook, Instagram, Youtube } from 'react-bootstrap-icons';

//const host = 'http://localhost:3000/'
const host = 'https://avage.mx/'

const portafolio = [
  /*{
    src: host + 'products/product_01.jpg',
    width: 1000,
    height: 1500,
    title: '',
    desc: <ul>
      <li>Ácido Cítrico RZBC | TTCA</li>
      <li>Ácido Esteárico Triple Prensado</li>
      <li>Ácido Fumárico</li>
      <li>Ácido Láurico</li>
      <li>Ácido Mirístico</li>
      <li>Ácido Oxálico Star | Indian</li>
      <li>Ácido Sulfámico</li>
    </ul>
  },*/
  /*{
    src: host + 'products/product_02.jpg',
    width: 1000,
    height: 1345,
    title: 'Commodities',
    desc: <> <br/><br/><br/> </>
    <Container>
      <Row>
        <Col>
          <ul>
            <li>Ácido Cítrico RZBC | TTCA</li>
            <li>Ácido Esteárico Triple Prensado</li>
            <li>Ácido Fumárico</li>
            <li>Ácido Láurico</li>
            <li>Ácido Mirístico</li>
            <li>Ácido Oxálico Star | Indian</li>
            <li>Ácido Sulfámico</li>

            <li>Bifluoruro Amonio</li>
            <li>Cloruro de Zinc</li>
            <li>Glicerina</li>
            <li>Goma Xantana M-80</li>
          </ul>
        </Col>
        <Col>
          <ul>
            <li>Nitrato de Sodio SQM</li>
            <li>Potasa Cáustica Escamas UNID</li>
            <li>Sosa Cáustica Escamas Rokita</li>

            <li>Sosa Microperlas Nouryon</li>
            <li>Sulfito de Sodio</li>
            <li>Acetato de Sodio</li>
            <li>Bicarbonato de Sodio Integral</li>
            <li>Diacetado de Sodio</li>
            <li>Hidrosulfito de Sodio</li>
            <li>Potasa Cáustica Escamas China</li>
          </ul>
        </Col>
      </Row>
    </Container>
    <ul>
      <li>Ácido Cítrico RZBC | TTCA</li>
      <li>Ácido Esteárico Triple Prensado</li>
      <li>Ácido Fumárico</li>
      <li>Ácido Láurico</li>
      <li>Ácido Mirístico</li>
      <li>Ácido Oxálico Star | Indian</li>
      <li>Ácido Sulfámico</li>

      <li>Bifluoruro Amonio</li>
      <li>Cloruro de Zinc</li>
      <li>Glicerina</li>
      <li>Goma Xantana M-80</li>
      <li>Nitrato de Sodio SQM</li>
      <li>Potasa Cáustica Escamas UNID</li>
      <li>Sosa Cáustica Escamas Rokita</li>

      <li>Sosa Microperlas Nouryon</li>
      <li>Sulfito de Sodio</li>
      <li>Acetato de Sodio</li>
      <li>Bicarbonato de Sodio Integral</li>
      <li>Diacetado de Sodio</li>
      <li>Hidrosulfito de Sodio</li>
      <li>Potasa Cáustica Escamas China</li>
    </ul>
  },*/
  /*{
    src: host + 'products/product_03.jpg',
    width: 1000,
    height: 667,
    title: '',
    desc: <ul>
      <li>Sosa Microperlas Nouryon</li>
      <li>Sulfito de Sodio</li>
      <li>Acetato de Sodio</li>
      <li>Bicarbonato de Sodio Integral</li>
      <li>Diacetado de Sodio</li>
      <li>Hidrosulfito de Sodio</li>
      <li>Potasa Cáustica Escamas China</li>
    </ul>
  },*/
  /*{
    src: host + 'products/product_05.jpg',
    width: 1000,
    height: 667,
    title: 'Amidas',
    desc: <ul>
      <li>Dietanol Amida Láurica</li>
      <li>Mono Etanol Amida de Coco</li>
    </ul>
  },*/
  {
    src: host + 'products/product_02.jpg',
    width: 1000,
    height: 1345,
    title: 'Commodities',
    desc: <> <br/><br/><br/> </>
  },
  {
    src: host + 'products/product_06.jpg',
    width: 1000,
    height: 668,
    title: 'Ésteres de Glicerilo',
    desc: <ul>
      <li>Mono Estearato de Glicerilo</li>
      <li>Mono Estearato de Glicerilo autoemulsionable</li>
      <li>Mono Estearato de Glicerilo PEG 100 estearato</li>
      <li>Monolaurato de Glicerilo</li>
    </ul>
  }, {
    src: host + 'products/product_04.jpg',
    width: 1000,
    height: 667,
    title: 'Ésteres de Ácidos Grasos',
    desc: <ul>
      <li>Palmitato de Cetilo</li>
      <li>Estearato de Octilo</li>
      <li>Estearato de Butilo</li>
      <li>Estearato de Estearoilo</li>
      <li>Palmitato de Octilo</li>
      <li>Neopentil Glicol Caprilato Caprato</li>
      <li>Octil Benzoato</li>
      <li>Mono Estearato de Etilen Glicol</li>
      <li>Di Estearato de Etilen Glicol</li>
    </ul>
  }, {
    src: host + 'products/product_08.jpg',
    width: 1000,
    height: 667,
    title: 'Sulfosuccinatos',
    desc: <ul>
      <li>Dioctil Sulfosuccinato de Sodio</li>
      <li>Lauril Eter Sulfosuccinato di Sódico</li>
      <li>Lauril Sulfosuccinato di Sódico</li>
    </ul>
  },
  {
    src: host + 'products/product_09.jpg',
    width: 1000,
    height: 1500,
    title: 'Ésteres de Polietilen Glicol',
    desc: <ul>
      <li>Oleato de polietilen glicol Mono y di oleato de PEG, 400, 600, 1000</li>
      <li>Estearato de polietilen glicol Mono y di estearato de PEG 300, 400, 600 y 4000</li>
      <li>Laurato de polietilen glicol Mono y di laurato de polietilenglicol 400</li>
      <li>Síntesis de otros Ésteres de Glicoles y Polialcoholes: Ésteres de Pentaeritritol, Trimetilol Propano, Neopentil Glicol</li>
    </ul>
  },
  {
    src: host + 'products/product_10.jpg',
    width: 1000,
    height: 667,
    title: 'Ésteres de Octil Dodecanol',
    desc: <ul>
      <li>Octil dodecanol de Macadamia</li>
      <li>Octil dodecanol de Jojoba</li>
      <li>Octil dodecanol de Rosa Mosqueta</li>
    </ul>
  },
  /*{
    src: host + 'products/product_10.jpg',
    width: 1000,
    height: 667,
    title: 'Ésteres de Polioles',
    desc: <ul>
      <li>Di Estearato de Pentaeritritol</li>
      <li>Di Oleato de Pentaeritritol</li>
      <li>Oleato de Neopentil Glicol</li>
    </ul>
  },*/
  {
    src: host + 'products/product_07.jpg',
    width: 1000,
    height: 1000,
    title: 'Ésteres de Sorbitán',
    desc: <ul>
      <li>Mono Estearato de Sorbitán</li>
      <li>Mono Oleato de Sorbitán</li>
      <li>Mono Laurato de Sorbitán</li>
      <li>Trioleato de Sorbitán</li>
    </ul>
  },
]

function App() {
  const [goingUp, setGoingUp] = useState(false)
  const prevScrollY = useRef(0)

  const refHome = useRef()
  const refUs = useRef()
  const refProducts = useRef()
  const refContacto = useRef()

  useEffect(() => {

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      //var prevScrollYTemp = prevScrollY.current;
      
      if (prevScrollY.current < currentScrollY && goingUp) {
        setGoingUp(false);
      }
      if (prevScrollY.current > currentScrollY && !goingUp) {
        setGoingUp(true);
      }

      prevScrollY.current = currentScrollY;

      if(currentScrollY > 10) {
        document.getElementById("navbar-avage").className = "navbar-custom navbar navbar-expand-lg navbar-light fixed-top";
      } else {
        document.getElementById("navbar-avage").className = "navbar-custom-start navbar navbar-expand-lg navbar-dark fixed-top";
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);

  const handleClick = (eventKey) => {

    var element = eval(eventKey).current;
    var headerOffset = 90;
    var elementPosition = element.getBoundingClientRect().top;
    var offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });

    /*eval(eventKey).current.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })*/

  };

  return (
    <div>
      <FloatingWhatsApp 
        phoneNumber="5215635488050"
        accountName="Avage Química"
        className="wa-style"
        statusMessage="En linea"
        avatar={iconLogo}
        chatMessage="Hola, ¡Bienvenido a Avage Química! Nos alegra que nos escribas. ¿Cómo podemos ayudarte?"
        allowClickAway
        notification={false}
        />

      <Navbar onSelect={ handleClick } id="navbar-avage" fixed="top" bg="dark" expand="lg" className='navbar-custom-start navbar-dark'>
        <Container>
          <Navbar.Brand>  
            <img src={ logo } className='logo' onClick={ () => handleClick('refHome') }/>
          </Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
            </Nav>
            <Nav>
              <Nav.Link eventKey="refHome">Inicio</Nav.Link>
              <Nav.Link eventKey="refUs">¿Quiénes somos?</Nav.Link>
              <Nav.Link eventKey="refProducts">Productos</Nav.Link>
              <Nav.Link eventKey="refContacto">Contácto</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

    <div className='home-section' ref={refHome}>
      <Container>
        <Row>
          <Col md={5}>
            <div className='home-title-small'> En Avage tenemos Química </div>
            <div className='home-title'> Colaboramos en el crecimiento de su Negocio </div>
            <br/><br/>
            <div className='center-container'>
              <Button className='home-btn' onClick={ () => handleClick('refContacto')}>
                Contáctanos
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>

    <div className='us-section' ref={refUs}>
      <Container className='us-container'>
        <Row className="align-items-center">
          <Col md={ 12 } align="center">
            <div className='text-title'>¿Quiénes Somos?</div>
            <hr className='hr-title-big'/>
            <br/>
            <div className='text-desc'>Avage, somos una Empresa especializada en la venta de Productos Químicos; nos interesa ser participes en el crecimiento del negocio de nuestros clientes.</div>
            <br/>
            <div className='text-desc'>Buscamos el desarrollo constante, generando el valor agregado que requiere la Industria: Disponibilidad inmediata, calidad de materias primas, conocimiento técnico, competitividad e innovación.</div>
            <br/>
            <div className='text-desc'>Entendemos que la rapidez & flexibilidad son necesidades importantes para nuestros Socios Comerciales.</div>
            <br/>
            <div className='text-subtitle text-bold'> "Colaboramos en el crecimiento de su Negocio" </div>
          </Col>
        </Row>
        <br/><br/><br/>
        <Row className="align-items-center">
          <Container>
            <Row>
              <Col md={4}>
                <Container className='center-container'>
                  <Row>
                    <Col md={'auto'}>
                      <img src={chemical03} className='adn-icon' />
                    </Col>
                    <Col>
                      <div className='adn-title'> Misión </div>
                      <hr className='hr-title'/>
                      <div className='adn-desc'> Colaboramos en el crecimiento de su negocio; al Comercializar Materias Primas para la industria de forma eficiente. </div>
                    </Col>
                  </Row>
                </Container>
              </Col>
              <Col md={4}>
                <Container className='center-container top-paddin-container'>
                  <Row>
                    <Col md={'auto'}>
                      <img src={chemical01} className='adn-icon' />
                    </Col>
                    <Col>
                      <div className='adn-title'> Visión </div>
                      <hr className='hr-title'/>
                      <div className='adn-desc'> Valoramos el trabajo de nuestros Colaboradores, Proveedores & Clientes, para colocarnos como una Empresa reconocida en la industria. </div>
                    </Col>
                  </Row>
                </Container>
              </Col>
              <Col md={4}>
                <Container className='center-container top-paddin-container'>
                  <Row>
                    <Col md={'auto'}>
                      <img src={chemical02} className='adn-icon' />
                    </Col>
                    <Col>
                      <div className='adn-title'> Valores </div>
                      <hr className='hr-title'/>
                      <ul className='adn-desc' style={{ textAlign: 'left' }}>
                        <li className='adn-desc'> Hacemos lo ordinario extraordinario. </li>
                        <li className='adn-desc'> Somos honestos, íntegros, responsables & propositivos. </li>
                        <li className='adn-desc'> Nos agrada trabajar en Equipo. </li>
                        <li className='adn-desc'> Ponemos toda nuestra dedicación en lo que hacemos. </li>
                        <li className='adn-desc'> Comunicarnos con claridad es fundamental. </li>
                      </ul>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Row>
          </Container>
        </Row>
      </Container>
    </div>

    <div className='industria-section'>
      <Container>
        <Row>
          <Col>
            <div className='industria-title'> Industrias </div>
            <hr className='hr-title-big'/>
            <br/><br/><br/>
            <Container align="center">
              <Row>
                <Col md={ 3 } xs={ 6 }>
                  <div className='rouded-img' style={{ backgroundImage: 'url(' + quimica + ')' }}></div>
                  <div className='industria-desc'> Química </div>
                </Col>
                <Col md={ 3 } xs={ 6 }>
                  <div className='rouded-img' style={{ backgroundImage: 'url(' + alimentos + ')' }}></div>
                  <div className='industria-desc'> Alimentaría </div>
                </Col>
                <Col md={ 3 } xs={ 6 }>
                  <div className='rouded-img' style={{ backgroundImage: 'url(' + cosmetica + ')' }}></div>
                  <div className='industria-desc'> Cosmética </div>
                </Col>
                <Col md={ 3 } xs={ 6 }>
                  <div className='rouded-img' style={{ backgroundImage: 'url(' + tinta + ')' }}></div>
                  <div className='industria-desc'> Tintas </div>
                </Col>
                
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    </div>

    <div className='us-section' ref={refProducts}>
      <Container className='us-container'>
        <Row className="align-items-center">
          <Col md={ 12 } align="center">
            <div className='text-title'>Portafolio de Productos</div>
            <hr className='hr-title-big'/>
            <div className='text-subtitle'>Materias Primas para la Industria</div>
            <br/><br/>

            <Container>
              <PhotoAlbum className='bg-album' layout="columns" photos={portafolio}  columns={ isMobile ? 1 : 2 }
                  renderPhoto={({ photo, imageProps: { src, alt, style, ...restImageProps } }) => (
                    <div className='img-container' style={{ position: 'relative' }}>
                      <img src={src} alt={alt} style={{ ...style }} {...restImageProps} />
                      <div className="centered">
                        <img src={icons} className='products-icons'/>
                        <div className='product-desc'>
                          <div className='image-title'>{ photo.title }</div>
                          <hr className='img-line'/>
                          <div>{ photo.desc }</div>
                        </div>
                      </div>
                    </div>
                  )}
              />
            </Container>
          </Col>
        </Row>
      </Container>
    </div>

    <div className='lema-section'>
      <Container>
        <Row>
          <Col>
            <div className='lema-title-small'> "Lo hacemos a la Mexicana, </div>
            <div className='lema-title'> con ingenio, dedicación y entrega" </div>
            {/* <div className='lema-title-sub'> con ingenio, dedicación y entrega </div> */}
          </Col>
        </Row>
      </Container>
    </div>
    
    <div className='contact-section'>
      <Container>
        <Row className='align-items-center'>
          <Col md={6} className='no-padding team-img-web'>
            <div className="contact-img"/>
          </Col>
          <Col md={6} align="center">
            <div className='contact-section-text'>
              <div className='text-title'> Nuestro Equipo </div>
              <hr className='hr-title-big' style={{ backgroundColor: '#000' }}/>
              <br/>
              <div className='contact-title'> Administración </div>
              <div> "Generamos soluciones que dan valor agregado a nuestros clientes" </div>
              <br/>
              <div className='contact-title'> Área Comercial </div>
              <div> "Sabemos que una respuesta oportuna es fundamental para la toma de desiciones" </div>
              <br/>
              <div className='contact-title'> Logística </div>
              <div> "Entregamos a tiempo; es nuestro compromiso" </div>
            </div>
          </Col>
          <Col md={6} className='no-padding team-img-mobil'>
            <div className="contact-img"/>
          </Col>
        </Row>
      </Container>
    </div>

    <div className='contact-footer-section' ref={refContacto}>
      <Container>
        <Row>
          <Col align="center">
            <div className='contact-footer-title'> Trabajemos Juntos </div>
            <hr className='hr-title-big'/>
            <br/><br/>
            <Container align="center">
              <Row style={{ color: '#fff' }}>
                <Col md={ 3 }>
                  <div className='contact-title' style={{ color: '#fff' }}> DISPONIBILIDAD </div>
                  <div className='contact-desc'> Nuestro inventario nos permite ofrecer una respuesta oportuna. </div>
                </Col>
                <Col md={ 3 }>
                  <div className='contact-title' style={{ color: '#fff' }}> CALIDAD </div>
                  <div className='contact-desc'> Productos de Fabricantes reconocidos en la Industria. </div>
                </Col>
                <Col md={ 3 }>
                  <div className='contact-title' style={{ color: '#fff' }}> CONOCIMIENTO TÉCNICO </div>
                  <div className='contact-desc'> Asesoramos a nuestros clientes. </div>
                </Col>
                <Col md={ 3 }>
                  <div className='contact-title' style={{ color: '#fff' }}> PUNTUALIDAD </div>
                  <div className='contact-desc'> Sabemos la importancia de entregar a tiempo para que su negocio crezca. </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <br/><br/>
        <Row>
          <Col md={ 3 } xs={ 12 } align="center">
            <a href="https://maps.app.goo.gl/2o9hBPUqWb1oBttZ7">
              <div> <img src={ location } className='contact-icon'/> </div>
              <br/>
              <div className='contact-lines'> 
              Pantanos s/n, Atlanta, 54740, Cuautitlán Izcalli, Estado de México.
              </div>
            </a>
          </Col>
          <Col md={ 3 } xs={ 6 } align="center">
            <a href="tel:5593107004">
              <div> <img src={ phone } className='contact-icon'/> </div>
              <br/>
              <div className='contact-lines'> 
                Oficinas
                <br/>
                55 9310 7004
              </div>
            </a>
          </Col>
          <Col md={ 3 } xs={ 6 } align="center">
            <a href="https://wa.me/5215635488050">
              <div> <img src={ whats } className='contact-icon'/> </div>
              <br/>
              <div className='contact-lines'> 
                WhatsApp
                <br/>
                56 3548 8050
              </div>
            </a>
          </Col>
          <Col md={ 3 } xs={ 12 } align="center">
            <a href="mailto:administracion@avage.com.mx">
              <div> <img src={ mail } className='contact-icon'/> </div>
              <br/>
              <div className='contact-lines'> 
                Correo
                <br/>
                <div>administracion@avage.com.mx</div>
              </div>
            </a>
          </Col>
        </Row>
      </Container>
    </div>

    <div className='footer' >
      <Container>
        <Row className='align-items-end'>
          <Col md={ 4 } className='contact-icons'> 
            <img src={ chemical01 } className='footer-icon' />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <img src={ chemical02 } className='footer-icon' />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <img src={ chemical03 } className='footer-icon' /> </Col>
          <Col md={ 4 }> <img src={ logoWithe } className='footer-logo' onClick={ () => handleClick('refHome') }/> </Col>
          <Col md={ 4 }> <div className='footer-text'> 2025 Copyrights & Protected </div> </Col>
        </Row>
      </Container>
    </div>
      
    </div>
  );
}

export default App;
